module.exports = __webpack_public_path__ + "img/logo-seo.fcbbf2b2.png";